import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Tablemobile() {
  return (
    <section className="cost-of-mobile-development p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} className="m-auto text-center">
            <h2>
              Cost Of Mobile <span>App Development</span>
            </h2>
          </Col>
          <div class="grid-container">
            <div class="header show_mobile bg-pale-white">
              Type of Mobile App
            </div>
            <div class="header bg-pale-white">Simple App</div>
            <div class="header bg-pale-white">Mid-level App</div>
            <div class="header bg-pale-white">Complex/Custom App</div>

            <div class="header border_grey" style={{ textAlign: "left" }}>
              Description
            </div>
            <h4 class="mobile-header">Simple App</h4>
            <div class="content border_grey">
              <p>Simple and minimal user interface and navigation.</p>
              <p> Essential features and functionalities.</p>
              <p> Minimal programming complexity, quick development.</p>
              <p>
                The app can also be considered a minimum viable product (MVP).
              </p>
            </div>
            <h4 class="mobile-header">Mid-level App</h4>
            <div className="content border_grey">
              <p>
                Engaging interface with multi-step user flows and broader
                functionality. Accommodates various use cases, offers a few
                custom features, and incorporates data storage, and external API
                integrations. Requires a moderate level of technical expertise.
              </p>
            </div>

            <h4 class="mobile-header">Complex/Custom App</h4>
            <p>
              Advanced, dynamic interface with sophisticated interactions,
              complex business logic, and workflows. Demands custom back-end
              development, robust data structures, high-end UI/UX, and advanced
              technology integration for powering features and functionalities.
              The app requires senior-level technical expertise.
            </p>

            <div
              class="header bg-pale-white border_grey"
              style={{ textAlign: "left" }}
            >
              Cost of App Development
            </div>
            <h4 class="mobile-header">Simple App</h4>

            <div class="bg-pale-white header-head flex_num border_grey">
              $35,000 - $50,000
            </div>
            <h4 class="mobile-header">Mid-level App</h4>

            <div class="bg-pale-white header-head flex_num border_grey">
              $50,000 - $120,000
            </div>
            <h4 class="mobile-header">Complex/Custom App</h4>
            <div class="bg-pale-white header-head flex_num">$350,000+</div>

            <div class="header border_grey" style={{ textAlign: "left" }}>
              Top 5 Aspects that Impact the Cost of App Development
            </div>

            <div class="aspects">
              <ol>
                <li>
                  <strong>Features and Functionality:</strong> The more complex
                  the features and functionalities required in your app, the
                  higher the development costs can be.
                </li>
                <li>
                  <strong>Platform Compatibility:</strong> Developing apps for
                  multiple platforms, i.e., iOS, Android, or cross-platform
                  frameworks like Flutter or React Native can impact the overall
                  cost of app development.
                </li>
                <li>
                  <strong>UI/UX Complexity:</strong> The complexity of UI/UX
                  design can increase or decrease the cost of developing an app.
                </li>
                <li>
                  <strong>Development Time and Resources:</strong> The duration
                  of development and the number of resources, their experience,
                  expertise, and other associated aspects.
                </li>
                <li>
                  <strong>Support and Maintenance:</strong> Post-launch
                  maintenance and support for the app are essential for keeping
                  the app updated and performing well. This can be a recurring
                  cost for businesses and entrepreneurs.
                </li>
              </ol>
            </div>
          </div>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} className="m-auto text-center">
            <Link
              to="/app-cost-calculator"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get Your App’s Cost
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Tablemobile;
